import { Menu } from '@base-ui/react/menu'
import { twMerge } from 'tailwind-merge'
import { listItemVariants } from '../../../lib/list-styles'
import type { PartProps } from '../../../lib/part-props'

interface MenuCheckboxItemProps extends PartProps<Menu.CheckboxItem.Props> {
  className?: string
}

/** The same row as Menu.Item. Its indicator trails the label, wherever it sits in the markup. */
function MenuCheckboxItem({ className, children, ...props }: MenuCheckboxItemProps) {
  return (
    <Menu.CheckboxItem data-slot="list-item" className={twMerge(listItemVariants(), className)} {...props}>
      {children}
    </Menu.CheckboxItem>
  )
}

export { MenuCheckboxItem }
